import { createSvgIcon } from "@mui/material";

export const PreviewIcon = createSvgIcon(
  <svg viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12338_13710)">
      <path
        d="M7.49306 10.0001C7.35249 10.0001 7.21192 9.9963 7.06745 9.98861C4.04519 9.83096 1.29236 7.97 0.0545603 5.2516C-0.0860097 4.94016 0.0545603 4.57873 0.366938 4.43647C0.683221 4.29805 1.05027 4.43647 1.19474 4.74791C2.24511 7.05105 4.57623 8.62364 7.13773 8.75822C9.96475 8.90817 12.6395 7.29328 13.8031 4.74791C13.9437 4.43647 14.3146 4.29805 14.6309 4.43647C14.9472 4.57489 15.0877 4.94016 14.9433 5.2516C13.6274 8.13149 10.6715 10.0001 7.49306 10.0001Z"
        fill="#2962FF"
      />
      <path
        d="M0.624982 5.61685C0.539078 5.61685 0.453174 5.59763 0.371175 5.56302C0.0548921 5.4246 -0.085678 5.05933 0.0587968 4.74789C1.42936 1.74112 4.59218 -0.162138 7.93072 0.0108854C10.953 0.168529 13.7058 2.0295 14.9436 4.74789C15.0842 5.05933 14.9436 5.42076 14.6312 5.56302C14.3149 5.70144 13.9479 5.56302 13.8034 5.25158C12.7531 2.94844 10.4219 1.37585 7.86044 1.24128C5.03732 1.09132 2.35868 2.70621 1.19507 5.25158C1.08964 5.48228 0.86317 5.61685 0.624982 5.61685Z"
        fill="#2962FF"
      />
      <path
        d="M7.49704 7.53544C6.07572 7.53544 4.92383 6.39733 4.92383 5.00161C4.92383 3.60588 6.07963 2.46777 7.49704 2.46777C8.91446 2.46777 10.0703 3.60588 10.0703 5.00161C10.0703 6.39733 8.91836 7.53544 7.49704 7.53544ZM7.49704 3.69816C6.77857 3.69816 6.17334 4.29413 6.17334 5.00161C6.17334 5.70908 6.77857 6.30505 7.49704 6.30505C8.21551 6.30505 8.82074 5.70908 8.82074 5.00161C8.82074 4.29413 8.21551 3.69816 7.49704 3.69816Z"
        fill="#2962FF"
      />
      <ellipse
        cx="7.50028"
        cy="4.82101"
        rx="2.14286"
        ry="1.60714"
        fill="#2962FF"
      />
    </g>
  </svg>,
  "Preview"
);
